import React from "react";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <div className="header-menu-wrapper">
      <div className="header">
        <div className="row w-100 h-25 ps-5 pe-5 me-5">
          <ul className="header-menu">
            <li>
              <Link className="item-link" to="/">
                صفحه اصلی
              </Link>
            </li>
            <li>
              <Link className="item-link" to="/about">
                درباره ما
              </Link>
            </li>
            <li>
              <Link className="item-link" to="/help">
                راهنمای استفاده{" "}
              </Link>
            </li>
            <li>
              <Link className="item-link" to="/faq">
                سوالات متداول
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
